import React, { useState } from "react";
import axios from "axios";
import { API } from "./api";
import VidhyaWordmark from "./components/VidhyaWordmark";

// Public page the Vidhya Autofill extension opens via chrome.identity.launchWebAuthFlow.
// It reads the OAuth params from the URL, authenticates the student, and (on
// approve) bounces back to the extension's redirect URI with a single-use code.
export default function OAuthAuthorize() {
  const params = new URLSearchParams(window.location.search);
  const scope = params.get("scope") || "profile.autofill.read";
  const redirectUri = params.get("redirect_uri") || "";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const valid = redirectUri.endsWith(".chromiumapp.org/") && params.get("code_challenge") && params.get("client_id");

  const approve = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const r = await axios.post(`${API}/oauth/authorize`, {
        email, password,
        client_id: params.get("client_id"),
        redirect_uri: redirectUri,
        state: params.get("state") || "",
        code_challenge: params.get("code_challenge"),
        code_challenge_method: params.get("code_challenge_method") || "S256",
        scope,
      });
      window.location.assign(r.data.redirect_url);
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Couldn't sign you in. Check your details and try again.");
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--paper, #faf8f5)", padding: 20 }} data-testid="oauth-authorize-page">
      <div style={{ width: 420, maxWidth: "100%", background: "#fff", border: "1px solid var(--line, #e7e3dc)", borderRadius: 16, padding: 28, boxShadow: "0 10px 40px rgba(0,0,0,.06)" }}>
        <div style={{ marginBottom: 18 }}><VidhyaWordmark size={30} /></div>
        <div className="eyebrow">Browser extension</div>
        <h1 style={{ fontSize: 22, margin: "6px 0 4px" }}>Authorize <em>Vidhya Autofill</em></h1>
        <p style={{ fontSize: 13.5, color: "#6b6b6b", lineHeight: 1.6, margin: "0 0 18px" }}>
          The extension is asking to <strong>read your saved application details</strong> so it can autofill university forms. It can't see your password, can't submit applications, and can't access your essays.
        </p>

        {!valid ? (
          <div className="auth-error" data-testid="oauth-invalid">This authorization link is invalid or incomplete. Please re-launch from the extension.</div>
        ) : (
          <form onSubmit={approve}>
            {err && <div className="auth-error" data-testid="oauth-error" style={{ marginBottom: 12 }}>{err}</div>}
            <label className="p-label">Email</label>
            <input className="input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="oauth-email" style={{ marginBottom: 12 }} />
            <label className="p-label">Password</label>
            <input className="input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="oauth-password" style={{ marginBottom: 16 }} />
            <div style={{ fontSize: 12, color: "#6b6b6b", background: "var(--paper-2, #f3efe9)", borderRadius: 8, padding: "8px 10px", marginBottom: 16 }}>
              Grants: <strong>{scope}</strong>
            </div>
            <button className="btn-primary" type="submit" disabled={busy} data-testid="oauth-approve-btn" style={{ width: "100%" }}>
              {busy ? "Authorizing…" : "Sign in & allow access"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
